/* ============================================================
   Cart Rewards — barre de progression multi-paliers (style PAALM)
   - 100% piloté par l'éditeur (blocs cart_tier). Aucun montant/texte en dur.
   - Devise client via Shopify Markets (Shopify.currency.active + Intl), jamais codée en dur.
   - Total réel Shopify (cart.total_price, après réductions).
   - AUTONOME : n'édite pas le JS du drawer existant. Se met à jour seul
     à chaque mutation du panier en chaînant window.fetch.
   ============================================================ */
(function () {
  'use strict';
  if (window.__cartRewardsInit) return;
  window.__cartRewardsInit = true;

  var locale = (document.documentElement.lang || 'en').slice(0, 5);
  var _fmtCache = {};

  // Devise = Shopify Markets (SOURCE UNIQUE). Shopify.currency.active = devise active du
  // storefront, identique à celle de la page panier. AUCUNE devise codée en dur :
  // repli = devise de la boutique injectée via data-shop-currency.
  function activeCurrency() {
    var bar = document.getElementById('CartRewardBar');
    return (window.Shopify && Shopify.currency && Shopify.currency.active)
      || (bar && bar.getAttribute('data-shop-currency'))
      || '';
  }

  function money(cents) {
    var cur = activeCurrency();
    var amount = (cents || 0) / 100;
    try {
      var nf = _fmtCache[cur] || (_fmtCache[cur] = new Intl.NumberFormat(locale, { style: 'currency', currency: cur }));
      return nf.format(amount);
    } catch (e) {
      return amount.toFixed(2) + (cur ? ' ' + cur : '');
    }
  }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Lit les paliers configurés (blocs cart_tier) depuis le DOM
  function readTiers(bar) {
    var tiers = [];
    bar.querySelectorAll('[data-tier]').forEach(function (n) {
      var amount = parseFloat(n.getAttribute('data-amount'));
      if (isNaN(amount)) return;
      tiers.push({
        cents: Math.round(amount * 100),
        name: n.getAttribute('data-name') || '',
        text: n.getAttribute('data-text') || '',
        image: n.getAttribute('data-image') || '',
        link: n.getAttribute('data-link') || ''
      });
    });
    tiers.sort(function (a, b) { return a.cents - b.cents; });
    return tiers;
  }

  function renderBar(cart) {
    var bar = document.getElementById('CartRewardBar');
    if (!bar || bar.getAttribute('data-disabled') === '1') return;
    var tiers = readTiers(bar);
    if (!tiers.length || !cart || !cart.item_count) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';

    // Montants en devise PRÉSENTÉE (cart.total_price /cart.js). La devise affichée vient de
    // activeCurrency() (Shopify.currency.active), jamais codée en dur.
    var total = cart.total_price || 0; // total réel Shopify (après réductions)
    var maxCents = tiers[tiers.length - 1].cents || 1;

    // Palier verrouillé suivant
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total < tiers[i].cents) { next = tiers[i]; break; }
    }

    // Titre évolutif
    var head = bar.querySelector('[data-reward-head]');
    if (head) {
      if (!next) {
        head.innerHTML = esc(bar.getAttribute('data-complete-text') || '');
      } else {
        var tpl = bar.getAttribute('data-progress-text') || '';
        var remaining = money(next.cents - total);
        head.innerHTML = esc(tpl).replace('[montant]', '<strong>' + esc(remaining) + '</strong>');
      }
    }

    // Remplissage (vers le dernier palier)
    var fill = bar.querySelector('[data-reward-fill]');
    if (fill) fill.style.width = Math.min((total / maxCents) * 100, 100) + '%';

    // Jalons
    var markers = bar.querySelector('[data-reward-markers]');
    if (markers) {
      markers.innerHTML = tiers.map(function (t) {
        var pos = Math.min((t.cents / maxCents) * 100, 100);
        var unlocked = total >= t.cents;
        return '<span class="cart-reward__marker' + (unlocked ? ' is-unlocked' : '') + '" style="left:' + pos + '%">' +
          '<span class="cart-reward__marker-label">' + esc(money(t.cents)) + '</span></span>';
      }).join('');
    }

    // Cartes cadeaux (cumulatif, ✓ quand débloqué)
    var gifts = bar.querySelector('[data-reward-gifts]');
    if (gifts) {
      gifts.innerHTML = tiers.map(function (t) {
        var unlocked = total >= t.cents;
        var isNext = next && !unlocked && t.cents === next.cents;
        var cls = unlocked ? 'is-unlocked' : (isNext ? 'is-next' : 'is-locked');
        var visual = t.image
          ? '<img src="' + esc(t.image) + '" alt="" loading="lazy">'
          : '🎁';
        // Débloqué : ✓ + état "Débloqué" ; verrouillé : montant requis
        var state = unlocked ? (t.text || 'Débloqué') : money(t.cents);
        var tag = t.link ? 'a' : 'div';
        var href = t.link ? ' href="' + esc(t.link) + '"' : '';
        return '<' + tag + href + ' class="cart-reward__gift ' + cls + '">' +
          '<span class="cart-reward__gift-visual">' + visual +
            '<span class="cart-reward__check">✓</span>' +
          '</span>' +
          '<span class="cart-reward__gift-text">' +
            '<span class="cart-reward__gift-name">' + esc(t.name) + '</span>' +
            '<span class="cart-reward__gift-state">' + esc(state) + '</span>' +
          '</span></' + tag + '>';
      }).join('');
    }
  }

  function renderBump(cart) {
    var bump = document.getElementById('CartOrderBump');
    if (!bump) return;
    var pid = parseInt(bump.getAttribute('data-product-id'), 10);
    var inCart = cart && cart.items && cart.items.some(function (it) { return it.product_id === pid; });
    bump.style.display = (cart && cart.item_count && !inCart) ? '' : 'none';
  }

  var _busy = false;
  function refresh() {
    if (_busy) return;
    _busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBar(cart); renderBump(cart); })
      .catch(function () {})
      .then(function () { _busy = false; });
  }

  // Ajout AJAX de l'upsell (sans recharger la page)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bump-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    btn.classList.add('is-loading');
    var original = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .catch(function () {})
      .then(function () {
        btn.classList.remove('is-loading');
        btn.textContent = original;
        refresh();
      });
  });

  // Mise à jour à chaque mutation panier, sans toucher au JS existant :
  // on enveloppe window.fetch en chaînant proprement.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var p = nativeFetch.apply(this, args);
    var url = (args[0] && args[0].url) ? args[0].url : args[0];
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 130); }).catch(function () {});
    }
    return p;
  };

  function init() { refresh(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(refresh, 60); });
})();
